import React, { useState } from 'react';
import { FiShare2, FiMail, FiFacebook, FiLinkedin, FiTwitter } from 'react-icons/fi';
import { EmailShareButton, FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share';
import { getWindowProp } from '../utils/dom';
import css from './Share.module.css';

const Share = React.memo(({ title }) => {
	const [open, setOpen] = useState(false);

	const onClick = (e) => {
		e.preventDefault();
		setOpen(!open);
	};

	const url = getWindowProp('location').toString();
	return (
		<div className={css.root}>
			<a href="#" onClick={onClick}>
				<FiShare2 />
				<span>Share</span>
			</a>
			{open && (
				<div className={css.popup}>
					<EmailShareButton subject={title} body={`${title}:`} url={url} className={css.btn}>
						<FiMail />
						<span>Email</span>
					</EmailShareButton>
					<FacebookShareButton quote={title} url={url} className={css.btn}>
						<FiFacebook />
						<span>Facebook</span>
					</FacebookShareButton>
					<TwitterShareButton title={title} url={url} className={css.btn}>
						<FiTwitter />
						<span>Twitter</span>
					</TwitterShareButton>
					<LinkedinShareButton title={title} url={url} className={css.btn}>
						<FiLinkedin />
						<span>LinkedIn</span>
					</LinkedinShareButton>
				</div>
			)}
		</div>
	);
});

export default Share;
